import React from 'react';
import { thoughtLeadership } from '../mock';
import { TrendingUp, BarChart3, ImagePlus, Video } from 'lucide-react';

const ThoughtLeadership = () => {
  return (
    <section className="thought-section-clean">
      <div className="thought-container-clean">
        <h2 className="section-title-clean">Thought Leadership</h2>
        <p className="section-subtitle-clean">Industry Recognition & Content Impact</p>

        <div className="metrics-row">
          <div className="metric-card-clean">
            <TrendingUp size={32} />
            <span className="metric-value-clean">{thoughtLeadership.sentiment}</span>
            <span className="metric-label-clean">Positive Sentiment</span>
            <span className="metric-source-clean">via Kaito</span>
          </div>

          <div className="metric-card-clean">
            <BarChart3 size={32} />
            <span className="metric-value-clean">{thoughtLeadership.growth}</span>
            <span className="metric-label-clean">YoY Mention Growth</span>
            <span className="metric-source-clean">Industry Analysis</span>
          </div>
        </div>

        <div className="articles-list">
          <h3 className="articles-header">{thoughtLeadership.platform}</h3>
          {thoughtLeadership.articles.map((article) => (
            <div key={article.id} className="article-item-with-media">
              <div className="article-content">
                <span className="article-category">{article.category}</span>
                <h4 className="article-title-clean">{article.title}</h4>
                <p className="article-excerpt-clean">{article.excerpt}</p>
                <span className="article-date-clean">{article.date}</span>
              </div>
              <div className="article-media-placard">
                {article.mediaUrl ? (
                  article.mediaType === 'video' ? (
                    <video 
                      src={article.mediaUrl} 
                      autoPlay 
                      loop 
                      muted 
                      playsInline
                      className="article-media-content"
                    />
                  ) : (
                    <img 
                      src={article.mediaUrl} 
                      alt={article.title}
                      className="article-media-content"
                    />
                  )
                ) : (
                  <div className="media-placeholder">
                    {article.mediaType === 'video' ? (
                      <Video size={32} />
                    ) : (
                      <ImagePlus size={32} />
                    )}
                    <span>Add {article.mediaType === 'video' ? 'Video' : 'Image'}</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ThoughtLeadership;